import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AppSettingsService as _appSettings } from './app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class NumericalWeatherService {

  constructor(private _http: HttpClient, private _auth: AuthService) { }

  public model = 'numeric-weather';

  get6(id, hour): Observable<NumWeather[]> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/6/' + id + '/' + hour;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<NumWeather[]>(uri, {headers: headers});
  }

  get2(id): Observable<NumWeather[]> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/2/' + id;
    const headers = new HttpHeaders()
    // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<NumWeather[]>(uri, {headers: headers});
  }
  
  get12(id): Observable<NumWeather[]> {
    const uri = _appSettings.API_ENDPOINT_OTHER + this.model + '/12/' + id;
    const headers = new HttpHeaders()
      // .set('Authorization', 'Bearer ' + this._auth.getToken())
      .set('accept', '*/*');
    return this._http.get<NumWeather[]>(uri, {headers: headers});
  }
}

interface NumWeather {
  "DATES": string,
  "CITY_ID": number,
  "ADVANCE_TIME": number,
  "ID_WEATHER": number,
  "TMP": number,
  "TMP_MIN": number,
  "TMP_MAX": number,
  "PRECIP": number,
  "SNOW": number,
  "RH": number,
  "WINDSP": number,
  "WINDDIR": number,
  "GUST": number,
  "GROZA": number,
  "GOLOLED": number,
  "TUMAN": number,
  "VIS": number,
  "PRESSURE": number,
  "PRESSURE_MODIF": number,
  "Date_write": string,
  "id_weather": number,
  "ww": number,
  "TypeWeather": string,
  "TypeWeather_by": string
}